import * as React from "react";

import { DatasheetItem } from "@modules/datasheets/components/datasheet-item";
import { TextElementProps } from "./text-element.controller";

import { DatasheetComponentTextStyle } from "@common/dto/datasheet/component-settings/text-style";

import { FieldContainer } from "../field-container";

import "./text-element.styles.scss";

export const TextElement: React.FC<TextElementProps> = React.memo((props) => {
  const { datasheetElement } = props;

  return (
    <DatasheetItem
      style={{
        top: datasheetElement.coordinates.y,
        left: datasheetElement.coordinates.x,
        display: "block",
      }}
    >
      <FieldContainer
        width={datasheetElement.original.width}
        height={datasheetElement.original.height}
      >
        <div
          className="DatasheetsResultTextElement"
          style={{
            fontSize: datasheetElement.original.fontsize,
            fontFamily: datasheetElement.original.fontname,
            color: datasheetElement.original.fontColor ? datasheetElement.original.fontColor.toString() : undefined,
            fontWeight: datasheetElement.original.textstyle.includes(DatasheetComponentTextStyle.bold)
              ? 700
              : undefined,
            fontStyle: datasheetElement.original.textstyle.includes(DatasheetComponentTextStyle.italic)
              ? "italic"
              : undefined,
            textDecoration: datasheetElement.original.textstyle.includes(DatasheetComponentTextStyle.underline)
              ? "underline"
              : undefined,
          }}
        >{datasheetElement.original.text}</div>
      </FieldContainer>
    </DatasheetItem>
  );
});
